/**
 * Defaults Globales - Vuetify
 *
 * Configuración base aplicada a todos los componentes
 */

import { buttonDefaults } from './buttons'
import { cardDefaults } from './cards'
import { formDefaults } from './forms'
import { dialogDefaults } from './dialogs'
import { feedbackDefaults } from './feedback'
import { navigationDefaults } from './navigation'
import { dataDefaults } from './data'
import { layoutDefaults } from './layout'

export const defaults: Record<string, Record<string, unknown> | undefined> = {
  global: {
    // Deshabilitar ripple para mejor rendimiento (opcional)
    // ripple: false,
  },

  ...buttonDefaults,
  ...cardDefaults,
  ...formDefaults,
  ...dialogDefaults,
  ...feedbackDefaults,
  ...navigationDefaults,
  ...dataDefaults,
  ...layoutDefaults,
}
